import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { NavigationError, Router } from '@angular/router';

const reloadKey = 'hrm.chunk-reload-attempted';

function isChunkLoadError(error: unknown): boolean {
  const wrappedError = error as {
    name?: unknown;
    message?: unknown;
    rejection?: unknown;
    originalError?: unknown;
  };
  const actualError = wrappedError?.rejection ?? wrappedError?.originalError ?? error;

  if (!actualError || typeof actualError !== 'object') {
    return false;
  }

  const { name, message } = actualError as { name?: unknown; message?: unknown };
  const errorName = typeof name === 'string' ? name : '';
  const errorMessage = typeof message === 'string' ? message : '';

  return (
    errorName === 'ChunkLoadError' ||
    /loading chunk .+ failed|failed to fetch dynamically imported module|importing a module script failed/i.test(
      errorMessage,
    )
  );
}

function reloadOnce(url?: string): void {
  if (sessionStorage.getItem(reloadKey)) {
    sessionStorage.removeItem(reloadKey);
    return;
  }

  sessionStorage.setItem(reloadKey, 'true');
  window.location.assign(url ?? window.location.href);
}

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  private readonly zone: NgZone;

  constructor(zone: NgZone) {
    this.zone = zone;
  }

  handleError(error: unknown): void {
    if (!isChunkLoadError(error)) {
      console.error(error);
      return;
    }

    this.zone.runOutsideAngular(() => reloadOnce());
  }
}

export function registerChunkErrorRecovery(router: Router): void {
  router.events.subscribe((event) => {
    if (event instanceof NavigationError && isChunkLoadError(event.error)) {
      reloadOnce(event.url);
    }
  });
}